module.exports = __webpack_public_path__ + "img/60.d4a91589.png";